var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAssetUtilise(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 14L14.25 11.75M14.25 11.75L16.5 14M14.25 11.75V16.25M9 12.125H5.625C4.57833 12.125 4.05499 12.125 3.62914 12.2542C2.67034 12.545 1.92003 13.2953 1.62918 14.2541C1.5 14.68 1.5 15.2033 1.5 16.25M10.875 6.125C10.875 7.98896 9.36396 9.5 7.5 9.5C5.63604 9.5 4.125 7.98896 4.125 6.125C4.125 4.26104 5.63604 2.75 7.5 2.75C9.36396 2.75 10.875 4.26104 10.875 6.125Z",
    stroke: "#667085",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetUtilise);
export default __webpack_public_path__ + "static/media/assetUtilise.8d968396ec45a6bb821c6fe9dba4ad96.svg";
export { ForwardRef as ReactComponent };